<main class="root">
  <!-- Skip to content link for accessibility -->
  <button
    class="skip-to-content"
    (click)="skipToContent()"
    aria-label="Direkt zu den aktiven Krediten springen"
    type="button"
  >
    Direkt zum Inhalt
  </button>

  <app-timeout-dialog></app-timeout-dialog>
  <div class="loader-line" *ngIf="activeService.loading"></div>
  <app-header
    [eternalPage]="activeService.eternalPage"
    [resultPage]="false"
    [loading]="activeService.loading"
    [loanFilterData]="activeService.dataLoan"
    [filterDataOptions]="activeService.dataFilterOptions"
    [offersData]="activeService.dataOffers"
    [twoApplicants]="false"
  >
  </app-header>
  <section class="resultpage" *ngIf="activeService.showDataOffers">
    <app-filter
      [filterData]="activeService.dataFilter"
      [filterOptionsData]="activeService.dataFilterOptions"
      [offersData]="activeService.dataOffers"
      (filterOutput)="postFilter()"
      [eternalPage]="activeService.eternalPage"
      [resultPage]="false"
      [loanRequestError]="false"
      [loanRequestErrorMessage]="''"
    ></app-filter>
    <div class="resultpage_inner-container">
      <ng-container *ngIf="+windowCouponAmount > 0">
        <app-coupon-panel></app-coupon-panel>
      </ng-container>
      <app-offer
        [loanFilterData]="activeService.dataLoan"
        [filterDataOptions]="activeService.dataFilterOptions"
        [offersData]="activeService.dataOffers"
        [noOffersData]="activeService.dataNoOffers"
        [time]="0"
        [showDefaultPlaceholders]="false"
        (filterOutput)="postFilter()"
        [eternalPage]="activeService.eternalPage"
        [resultPage]="false"
        [twoApplicants]="false"
        [apptrackToken]="''"
        [pageType]="'active'"
      ></app-offer>
    </div>
  </section>
  <app-track-conversion-funnel></app-track-conversion-funnel>
</main>
<div
  class="nooffers"
  *ngIf="activeService.eternalPage && !activeService.showDataOffers"
>
  <h1 class="nooffers__title">Keine aktiven Kredite</h1>
  <p class="nooffers__text">
    Aktuell befinden sich keine aktiven Kredite in Ihrem Kreditcenter
  </p>
  <a class="nooffers__link" href="https://www.check24.at/kredit"
    >jetzt Kredite vergleichen</a
  >
</div>
